declare var $: any;

export class LandComponent {
    static init() {
        $("input[type=radio]:checked", ".js-land-component").parent(".land-component-item-label")
            .addClass("land-component-item-label--active");
        $("input[type=radio]", ".js-land-component").change(LandComponent.toggleActive);
    }

    static toggleActive(e: Event) {
        const $radio = $(this);
        const $label = $radio.parent(".land-component-item-label");
        const $otherLabels = $label.siblings(".land-component-item-label");

        if ($radio.is(":checked")) {
            $label.addClass("land-component-item-label--active");
            $otherLabels.removeClass("land-component-item-label--active");
        }
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/components/landComponent.ts